import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { useFlags } from "launchdarkly-react-client-sdk";
import React, { memo } from "react";
import { CONTINUE_WITH_SAML_SSO_BTN } from "~/constants/testIDs";
export const ContinueWithSAMLSSOButton = /*#__PURE__*/ memo((param)=>{
    let { className, ...rest } = param;
    const { maintenanceModeJson } = useFlags();
    if (!!(maintenanceModeJson === null || maintenanceModeJson === void 0 ? void 0 : maintenanceModeJson.maintenanceMessage)) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "flex w-full items-center justify-center",
        children: /*#__PURE__*/ _jsx("button", {
            "data-testid": CONTINUE_WITH_SAML_SSO_BTN,
            className: tailwindMerge("text-14 font-medium text-grey-10 underline hover:text-grey-12", className),
            ...rest,
            children: "Continue with SAML SSO"
        })
    });
});
ContinueWithSAMLSSOButton.displayName = "ContinueWithSSOButton";
